import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Anchor, Gift, QrCode, Star } from 'lucide-react';
export function Slide07FinnsExperience() {
  const steps = [{
    icon: MapPin,
    text: 'Go to waterway'
  }, {
    icon: Anchor,
    text: 'Choose cast'
  }, {
    icon: Gift,
    text: 'Fish up real products'
  }, {
    icon: QrCode,
    text: 'QR code → pick up'
  }, {
    icon: Star,
    text: 'Review & data'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-92">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-93">
        Finns i Sjön: Consumer Experience
      </motion.h2>

      <div className="relative" data-id="element-94">
        {/* Connecting line */}
        <motion.div className="absolute top-8 left-0 right-0 h-0.5 bg-white/10" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1,
        ease: 'easeInOut'
      }} data-id="element-95" />

        <div className="grid grid-cols-5 gap-4 relative z-10" data-id="element-96">
          {steps.map((step, i) => <motion.div key={i} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: i * 0.15
        }} className="flex flex-col items-center text-center group" data-id="element-97">
              <div className="w-16 h-16 rounded-full bg-[#0a4d4d] border border-[#4fd1c5] flex items-center justify-center mb-6 shadow-lg shadow-[#4fd1c5]/10" data-id="element-98">
                <step.icon className="w-8 h-8 text-[#4fd1c5]" data-id="element-99" />
              </div>
              <p className="text-lg font-medium text-white max-w-[120px]" data-id="element-100">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        {/* Static Phone Mockup - Professional */}
        <motion.div className="mt-16 mx-auto w-64 h-96 bg-black rounded-[3rem] border-4 border-gray-800 relative overflow-hidden shadow-2xl" initial={{
        y: 50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.8
      }} data-id="element-101">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a4d4d] to-[#0d5858] flex flex-col items-center justify-center p-6" data-id="element-102">
            <Gift className="w-16 h-16 text-[#ffd700] mb-4" data-id="element-103" />
            <div className="text-center" data-id="element-104">
              <h3 className="text-white font-bold mb-2" data-id="element-105">You caught a prize!</h3>
              <p className="text-white/60 text-sm" data-id="element-106">
                Scan QR to redeem at nearest store
              </p>
            </div>
            <div className="mt-8 w-32 h-32 bg-white p-2 rounded-lg" data-id="element-107">
              <div className="w-full h-full bg-black/10" data-id="element-108" />
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}